import * as React from 'react';
import { cn } from '@/lib/utils';

type Tone = 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'brand';

const TONES: Record<Tone, string> = {
  neutral: 'bg-slate-100 text-slate-700',
  success: 'bg-green-100 text-green-700',
  warning: 'bg-amber-100 text-amber-700',
  danger: 'bg-red-100 text-red-700',
  info: 'bg-sky-100 text-sky-700',
  brand: 'bg-brand-50 text-brand-700',
};

export function Badge({
  tone = 'neutral',
  className,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & { tone?: Tone }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        TONES[tone],
        className,
      )}
      {...props}
    />
  );
}

/** Map any domain status onto a tone, so state reads the same on every screen. */
export function toneForStatus(status?: string | null): Tone {
  switch (status) {
    case 'AVAILABLE': case 'ACTIVE': case 'PAID': case 'COMPLETED': case 'READY':
    case 'SERVED': case 'CONFIRMED': case 'RECEIVED': case 'RESOLVED':
      return 'success';
    case 'PAYMENT_PENDING': case 'PREPARING': case 'PARTIALLY_PAID': case 'PAUSED':
    case 'PENDING': case 'SCHEDULED': case 'PARTIALLY_READY': case 'IN_RECOVERY':
      return 'warning';
    case 'OUT_OF_SERVICE': case 'CANCELLED': case 'VOIDED': case 'REFUNDED':
    case 'FAILED': case 'NO_SHOW': case 'ESCALATED':
      return 'danger';
    case 'OCCUPIED': case 'IN_USE': case 'SENT_TO_KITCHEN': case 'OPEN': case 'RELEASED':
      return 'info';
    default:
      return 'neutral';
  }
}
